export type ClientProposalDTO = {
  response: ProposalEntity[];
};

export const ProposalStatus = {
  DRAFT: 'draft',
  GENERATED: 'generated',
} as const;

export type ProposalEntity = {
  id: number;
  external_id: string;
  opportunity_external_id?: string;
  first_name: string;
  last_name: string;
  email?: string;
  residence_status: string;
  down_payment: number;
  client_external_id?: string;
  downpayment_amount: number;
  financed_fees: number | null;
  loan_amount: number;
  ltv: string;
  consultation_fee?: number;
  residiual_fees: boolean;
  show_dld_fee: boolean;
  status: (typeof ProposalStatus)[keyof typeof ProposalStatus];
  generated_at: string;
  show_mortgage_registration_fee: boolean;
  show_mortgage_release_fee: boolean;
  show_real_estate_fee: boolean;
  show_transfer_center_fee: boolean;
  show_bank_logos: boolean;
  show_client_name: boolean;
  phone_number?: string;
  mortgage_length: number;
  property_value: number;
  property_location: string;
  equity_release_amount?: number | null;
  is_documents_required: boolean;
  include_insurance_fees: boolean;
  created_at: string;
  updated_at: string;
  additional_borrowers?: AdditionalBorrowersEntity[];
  mortgage_type: string;
  property_status: string;
  property_emirate: string;
  bank_offers?: BankOffersEntity[];
  calculated_fees: CalculatedFees;
  transaction_type: string;
  employment_status: string;
  residency_status: string;
  existing_mortgage_type?: string;
  editable_until?: string;
  is_land_department_fee_financed: boolean;
  is_real_estate_fee_financed: boolean;
};

export type AdditionalBorrowersEntity = {
  email: string;
  first_name: string;
  last_name: string;
  phone_number?: string;
  residency_status: string;
  relationship: string;
  applicant_type: string;
};

export type BankOffersEntity = {
  id: number;
  bank_name: string;
  external_id: string;
  bank_logo: string;
  bank_icon: string;
  property_insurance_payment_period: string;
  life_insurance_payment_period: string;
  calculatedFees: any;
  overpayment_fee: string;
  additional_information: string;
  customer_segments: Record<string, any>[];
  fixed_until: number;
  early_settlement_fee: string;
  property_insurance_amount: number;
  life_insurance_amount: number;
  type_of_mortgage: string;
  minimum_rate: number;
  follow_on_rate?: string;
  monthly_payment: number;
  interest_rate: number;
  fixed_rate: string;
  variable_rate_addition: number;
  type_of_account?: null;
  eibor_type: string;
  life_insurance: number;
  property_insurance: null | number;
  home_valuation_fee: number;
  mortgage_processing_fee: number;
  mortgage_processing_fee_amount: number;
  eibor_rate: string;
  buyout_processing_fee: number;
  interest_rate_type: 'fixed' | 'variable';
  follow_on_rate_type?: null;
  is_exclusive: boolean;
  minimum_mortgage_processing_fee: number;
};

type Fees = {
  calculated_fee_amount: number
  fee_percentage: number;
  financed_fee_amount: number
  fixed_fee_amount: number
  required_up_front_fee_amount: number
  total_fee_amount: number
};

export type CalculatedFees = {
  land_department_transfer_fee: Fees & {
    financed_fee_amount: number | null;
  };
  mortgage_registration_fee: Omit<Fees, 'financed_fee_amount'>;
  mortgage_release_fee: Pick<Fees, 'required_up_front_fee_amount'>;
  real_estate_fee: Omit<Fees, 'fixed_fee_amount'> & {
    financed_fee_amount: number | null;
  };
  transfer_center_fee: Pick<Fees, 'required_up_front_fee_amount' | 'total_fee_amount'>;
  title_deed_fee: Pick<Fees, 'required_up_front_fee_amount'>;
  withdrawal_of_caveat_fee: Pick<Fees, 'required_up_front_fee_amount'>;
} & {
  total_fee_financed_amount: number;
};
